module.exports = __webpack_public_path__ + "assets/view_icon_userlist.8dc3107499cbc84efd110c3dc2362d96.svg";